import { ModuleInfo } from "fabrix/types";
import { createRetryableAfsRoute } from "./retryableAfsRoute";
import { icons } from "./icons";
import {
  afsExcelUiFinancialReportingImportsPageId,
  afsExcelUiLogisImportsPageId,
  afsExcelUiModuleId,
  afsExcelUiPageId,
  afsExcelUiProgrammeStructurePageId,
} from "./moduleIds";
import translationJson from "./translations.json";

const moduleRoutes = (): ModuleInfo => {
  return {
    path: "/afs-excel-ui/",
    label: "AFS_EXCEL_UI",
    name: "afs-excel-ui",
    id: afsExcelUiModuleId,
    lazy: createRetryableAfsRoute(() => import("./index"), "Online AFS"),
    translations: translationJson,
    icons: icons,
    children: [
      {
        path: "/afs-excel-ui/",
        order: 0,
        label: "AFS_EXCEL_UI",
        name: "excel-ui",
        icon: "afs-excel-ui",
        id: afsExcelUiPageId,
        lazy: createRetryableAfsRoute(() => import("./routes/WorkbookPageLoader"), "Online AFS"),
      },
      {
        // Keep this as a real module child with a stable page ID so RequireAuth
        // enforces the view/edit permission assigned to the user's role.
        path: "/afs-excel-ui/logis-imports",
        order: 1,
        label: "LOGIS imports",
        name: "logis-imports",
        icon: "afs-excel-ui",
        hide: true,
        id: afsExcelUiLogisImportsPageId,
        lazy: createRetryableAfsRoute(() => import("./routes/logis-imports"), "LOGIS imports"),
      },
      {
        path: "/afs-excel-ui/financial-reporting-imports",
        order: 2,
        label: "Financial reporting imports",
        name: "financial-reporting-imports",
        icon: "afs-excel-ui",
        hide: true,
        id: afsExcelUiFinancialReportingImportsPageId,
        lazy: createRetryableAfsRoute(() => import("./routes/financial-reporting-imports"), "Financial reporting imports"),
      },
      {
        path: "/afs-excel-ui/programme-structure",
        order: 3,
        label: "Programme Structure",
        name: "programme-structure",
        icon: "afs-excel-ui",
        hide: true,
        id: afsExcelUiProgrammeStructurePageId,
        lazy: createRetryableAfsRoute(() => import("./routes/programme-structure"), "Programme Structure"),
      },
    ],
  };
};

export default moduleRoutes;
